export default /* glsl */ `
vec3 noisePos = 0.2 * (position + noiseOffset);
vec3 transformed = vec3( position + 0.2 * vec3(snoise(noisePos.xy), snoise(noisePos.yz), snoise(noisePos.zx)));
`;
